import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { newRow, getFormattedDate } from "./constants";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import StatusCellComponent from '../../../../views/pages/manage/masters/studentFinancials/paymentCollectionSetup/securityDepositSequencing/StatusCellComponent.jsx';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import { getFormattedTime } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getStatusStyles } from '../../../../modules/studentTransfer/transferSetup/transferValidationConfig/constant.js'
import { selectStyles, inputStyles } from "../../../studentRefund/thirdPartyBankAccMaster/constants.jsx"
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { getBuAgainstBuTypes } from "modules/studentRefund/refundMasters/refundsApprovalConfig/services";

const ListComponent = forwardRef(
  (
    {
      currentPage = 0,
      currPageSize,
      rowCount,
      nextButtonHandler,
      dropdown,
      setDropdownData,
      rows,
      createUpdateHandler,
      toggleStatusHandler,
      isBranchLevelConfig,
      isUpdatePermission
    },
    ref
  ) => {
    const [rowModesModel, setRowModesModel] = useState({});

    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});
    const [buLoading, setBuLoading] = useState(false);
    const [buAgainstBranchType, setBuAgainstBranchType] = useState([]);

    useEffect(() => setRowData(rows), [rows]);

    const rowFormHandler = (value, key) =>
      setRowForm((prev) => ({ ...prev, [key]: value }));

    const startEditing = (id, form) => {
      setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
      setRowForm(form);
    };


    const stopEditing = () => {
      const currForm = { ...rowForm };
      setRowModesModel((oldModel) => ({
        [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
      }));
      setRowForm({});
    };

    const handleEditClick = (params) => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        startEditing(params?.id, params?.row);
      }
    };

    const handleCancelClick = async (params) => {
      if (params?.row?.isNew) {
        setRowData(rows);
        setRowForm({});
      } else {
        stopEditing(params?.id);
      }
    };

    const handleSaveClick = async (params) => {
      createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        let randomId = generateRandomId();
        let emptyRow = {
          ...newRow,
          isNew: true,
          id: randomId
        };
        startEditing(randomId, emptyRow);
        setRowData((prev) => [emptyRow, ...prev]);
      }
    };

    useImperativeHandle(ref, () => ({
      addNewRow: addNewRow,
      startEditing: startEditing,
      stopEditing: stopEditing,
    }));

    const buTypeChangeHandler = async (selectedBranchType) => {
      try {
        rowFormHandler(selectedBranchType, "branchType")
        let buAgainstBranchType = [];

        if (selectedBranchType) {
          buAgainstBranchType = await getBuAgainstBuTypes(selectedBranchType, setBuLoading);
        }
        rowFormHandler("", "businessArea")
        setBuAgainstBranchType(buAgainstBranchType);
      } catch (e) {
        console.log(e);
      }
    }

    const columns = [
      new AGridColDef("businessGroup", "Business Group*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessGroup}
              handleChange={(value) => rowFormHandler(value, "businessGroup")}
              items={dropdown?.businessGroup}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),

      new AGridColDef("companyCode", "Company Code*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.companyCode}
              handleChange={(value) => rowFormHandler(value, "companyCode")}
              items={dropdown?.companyCode}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("branchType", "Branch Type*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.branchType}
              // handleChange={(value) => rowFormHandler(value, "branchType")}
              handleChange={buTypeChangeHandler}
              items={dropdown?.branchType}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      ...(isBranchLevelConfig ? [new AGridColDef("businessArea", "Business Area*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessArea}
              handleChange={(value) => rowFormHandler(value, "businessArea")}
              items={buAgainstBranchType}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
              isLoading={buLoading}
            />
          </div>)
        )] : []),
      new AGridColDef("academicCareer", "Academic Career*", true)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.academicCareer}
              handleChange={(value) => rowFormHandler(value, "academicCareer")}
              items={dropdown?.academicCareer}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("effectiveDate", "Effective Date*", true)
        .setMinWidth(150)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => {
          const fomattedDate = moment(params?.value).format("DD-MMM-YYYY")
          return (
            params?.value ? <div><Tooltip title={fomattedDate}>
              <div className={`ellipsis-text-container`}>{fomattedDate}</div>
            </Tooltip></div> : <div>-</div>
          )
        })
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <CustomDatePickerV2
              placeHolder="Date"
              // maxDate={moment(new Date())}
              value={rowForm?.effectiveDate}
              width={"18px"}
              handler={(index, date, keyName) => {
                rowFormHandler(moment(date).startOf('day'), "effectiveDate",);
              }}
            />
          </div>
        )),
      new AGridColDef("submissionDays", "Submission Days*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value !== null && params?.value !== undefined ?
            <div><Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value} days</div>
            </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              value={rowForm?.submissionDays}
              handler={(val) => {
                if (val === "" || val === null) {
                  rowFormHandler("", "submissionDays");
                } else if (val >= 0 && val <= 999) {
                  rowFormHandler(val, "submissionDays");
                }
              }}
              placeholder={""}
              disabled={false}
              style={inputStyles}
              regex={regex?.numeric}
            />
          </div>)),
      new AGridColDef("approvalDays", "Approval Days*", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value !== null && params?.value !== undefined ? (
            <div>
              <Tooltip title={params?.value}>
                <div className="ellipsis-text-container">
                  {params?.value} days
                </div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )

        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              value={rowForm?.approvalDays}
              handler={(val) => {
                if (val === "" || val === null) {
                  rowFormHandler("", "approvalDays");
                } else if (val >= 0 && val <= 999) {
                  rowFormHandler(val, "approvalDays");
                }
              }}
              placeholder={""}
              disabled={false}
              style={inputStyles}
              regex={regex?.numeric}
            />
          </div>)),
      new AGridColDef("createdOn", "Created By	", false)
        .setMinWidth(230)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={`${params?.row?.createdBy} on ${getFormattedDate(params?.value)} ${getFormattedTime(params?.value)}`}>
                {`${params?.row?.createdBy} on ${getFormattedDate(params?.value)} ${getFormattedTime(params?.value)}`}
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("updatedOn", "Updated By", false)
        .setMinWidth(230)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={`${params?.row?.updatedBy} on ${getFormattedDate(params?.value)} ${getFormattedTime(params?.value)}`}>
                {`${params?.row?.updatedBy} on ${getFormattedDate(params?.value)} ${getFormattedTime(params?.value)}`}
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        ),

      new AGridColDef("status", "Status", false)
        .setMinWidth(100)
        .setFlex(1)
        .editable(true)
        .renderCellComponent((params) => (
          <CustomChip
            text={params?.value}
            textColor={getStatusStyles(params?.value)?.textColor}
            bgColor={getStatusStyles(params?.value)?.bgColor}
          />
        ))
        .renderEditCellComponent((params) => (<StatusCellComponent
          params={params}
          toggleStatusHandler={toggleStatusHandler}
          rowForm={rowForm}
          rowFormHandler={rowFormHandler}
        />
        ))
      ,
      new AGridColDef("actions", "Actions", false)
        .setMinWidth(130)
        .columnAlign("right")
        .setFlex(1)
        .renderCellComponent((params) => (
          <div className='d-flex align-items-center' style={{ gap: '15px' }}>
            <ActionsCellComponent
              mode={params.api.getRowMode(params?.id)}
              params={params}
              handleEditClick={handleEditClick}
              handleCancelClick={handleCancelClick}
              handleSaveClick={handleSaveClick}
              rowForm={rowForm}
              icon={true}
              cancelIcon={<CancelIcon
                className="mx-2 cursor"
                onClick={() => handleCancelClick(params)}
              />
              }
              editPermission={isUpdatePermission}
              customEditIcon
              isSaveDisabled={
                !rowForm?.businessGroup ||
                !rowForm?.companyCode ||
                !rowForm?.branchType ||
                (isBranchLevelConfig && !rowForm?.businessArea) ||
                !rowForm?.academicCareer ||
                !rowForm?.effectiveDate ||
                !rowForm?.submissionDays ||
                !rowForm?.approvalDays
              }
            />
          </div>

        )
        ),
    ];
    return (
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowCount}
          loading={false}
          currentPage={currentPage}
          nextButtonHandler={nextButtonHandler}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          paginationModel={{ page: currentPage, pageSize: currPageSize }}
        />
      </div>
    );
  }
);
export default ListComponent;
